/* eslint-disable @typescript-eslint/no-explicit-any */
import { baseUrl } from 'authConfig';
import { customFetch, customFetchBaseQuery } from './customFetch';
import { getHeaders, getHeadersObject, getTeamsToken } from 'helpers/utils';
import { createApi } from '@reduxjs/toolkit/query/react';
import axios from 'axios';

export const GetLatestUpdate = async (token?: string): Promise<Date> => {
  const res = await customFetch<Date>(`${baseUrl}v2/upns/latest-update`, {
    method: 'GET',
    headers: getHeadersObject(token),
  });
  try {
    return res;
  } catch (_) {
    throw new Error('Failed to get latest update');
  }
};

export const ResetCache = async (): Promise<boolean> => {
  const token = getTeamsToken();

  const result = await axios.put(`${baseUrl}v2/upns/reset-cache`, null, {
    headers: getHeadersObject(token),
  }).then((res) => res);

  if (result.status === 204) {
    return true;
  }

  return false;
};

export const PagedUpnRecords = createApi({
  reducerPath: 'identityApi',
  tagTypes: ['Identity'],
  baseQuery: customFetchBaseQuery({ baseUrl }),
  endpoints: (builder) => ({
    getIndentities: builder.mutation({
      query: ({ token, body }) => {
        const headers = getHeaders(token);
        let queryString = `?PageNo=${body?.page}&PageSize=${body?.limit}`;

        console.log(body);
        console.log('body above');

        body?.identityFilter.forEach((a: any) => {
          queryString += `&UserTypes=${a}`;
        });

        if (body?.numberFilter.includes(0)) {
          queryString += '&HasNoNumber=true';
        }

        if (body?.numberFilter.includes(1)) {
          queryString += '&HasNumber=true';
        }

        if (body?.voiceRouteFilter.includes(0)) {
          queryString += '&HasNoVoiceRoutePolicy=true';
        }

        if (body?.voiceRouteFilter.includes(1)) {
          queryString += '&HasVoiceRoutePolicy=true';
        }

        if (body?.dialPlanFilter.includes(0)) {
          queryString += '&HasNoTenantDialPlan=true';
        }

        if (body?.dialPlanFilter.includes(1)) {
          queryString += '&HasTenantDialPlan=true';
        }

        if (body?.licenseFilter.includes(0)) {
          queryString += '&HasNoVoiceLicense=true';
        }

        if (body?.licenseFilter.includes(1)) {
          queryString += '&HasVoiceLicense=true';
        }

        if (body?.licenseFilter.includes(1)) {
          queryString += '&HasVoiceLicense=true';
        }

        return {
          url: `v2/upns${queryString}&SearchString=${body?.search || ''}`,
          method: 'GET',
          headers,
          body,
        };
      },
      invalidatesTags: () => [{ type: 'Identity', id: 'LIST' }],
    }),
  }),
});

export const { useGetIndentitiesMutation } = PagedUpnRecords;